import { MantineThemeOverride } from '@mantine/core';

export type ListTheme = NonNullable<MantineThemeOverride['components']>['List'];

export const List: ListTheme = {
  // todo: define
};
